export default {
  resetFields(form) {
    Object.keys(form).map((key) => {
      form[key] = '';
    });

    return form;
  },
  hlaValidCount(hlas) {
    return hlas.filter((item) => {
      return item.secondAllele && item.firstAllele;
    }).length >= 3;
  }
}
